import { render, staticRenderFns } from "./attenMng.vue?vue&type=template&id=580f0bf1&scoped=true"
import script from "./attenMng.vue?vue&type=script&lang=js"
export * from "./attenMng.vue?vue&type=script&lang=js"
import style0 from "./attenMng.vue?vue&type=style&index=0&id=580f0bf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f0bf1",
  null
  
)

export default component.exports